import { render, staticRenderFns } from "./introductionRules.vue?vue&type=template&id=06374ffa&scoped=true&"
import script from "./introductionRules.vue?vue&type=script&lang=js&"
export * from "./introductionRules.vue?vue&type=script&lang=js&"
import style0 from "./introductionRules.vue?vue&type=style&index=0&id=06374ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06374ffa",
  null
  
)

export default component.exports